export default "__VITE_ASSET__DkgYnvNu__"